import React, { useState } from 'react';
import { Button } from 'primereact/button';
import ttecLogoUrl from '../../assets/Calculator.svg';
import groupExclam from '../../assets/groupExclam.svg';
import { CustomTextProgressbar } from '../../features/payoutCalculator/customTextProgressBar/CustomTextProgressBar';
import './payoutCalculator.scss';
import '../../styles/theme.scss';

interface propTypes {
    empMetricData: any;
}
export const PayoutCalculator = ({ empMetricData }: propTypes) => {
    const [target3, setTarget3] = useState<any>();
    const [target4, setTarget4] = useState<any>();
    const [target5, setTarget5] = useState<any>();
    const [enteredlessthan80HoursIsValid, setenteredlessthan80HoursIsValid] = useState(true);
    const [enteredgreaterthan180HoursIsValid, setenteredgreaterthan180HoursIsValid] = useState(true);
    const [enteredHours, setenteredHours] = useState('');
    const [enteredHoursIsValid, setenteredHoursIsValid] = useState(false);
    const [enteredHoursTouched, setenteredHoursTouched] = useState(false);

    const nameInputChangeHandler = (event: any) => {
        setenteredHours(event.target.value);
        setenteredlessthan80HoursIsValid(true);
        setenteredgreaterthan180HoursIsValid(true);
        hoursInputIsInvalid = false;
    };

    const formSubmissionHandler = (event: any) => {
        event.preventDefault();
        setenteredHoursTouched(true);
        if (enteredHours.trim() === '') {
            setenteredHoursIsValid(false);
            return;
        }
        setenteredHoursIsValid(true);
        const estimatehrs: any = enteredHours;
        if (estimatehrs < 80) {
            setenteredlessthan80HoursIsValid(false);
            return;
        }
        if (estimatehrs > 180) {
            setenteredgreaterthan180HoursIsValid(false);
            return;
        }

        const payrate = empMetricData.payrate;
        const metricValue3 = estimatehrs * payrate * empMetricData.max_minus_2_payout;
        const metricValue4 = estimatehrs * payrate * empMetricData.max_minus_1_payout;
        const metricValue5 = estimatehrs * payrate * empMetricData.max_metric_payout;

        setTarget3(metricValue3);
        setTarget4(metricValue4);
        setTarget5(metricValue5);

        setenteredHours('');
        setenteredlessthan80HoursIsValid(true);
        setenteredgreaterthan180HoursIsValid(true);
    };
    let hoursInputIsInvalid = !enteredHoursIsValid && enteredHoursTouched;

    const circularprogressbar = (count: number, reported: number) => (
        <CustomTextProgressbar count={count} total_reported={reported}>
            <div style={{ marginTop: '10px', marginLeft: '-3px' }}>
                <strong> {count}</strong>
            </div>
            <div>
                <strong> {'Metrics'}</strong>
            </div>
        </CustomTextProgressbar>
    );

    return (
        <>
            <h6 style={{ color: '#2B3A42', fontSize: '20px' }}> Payout Calculator</h6>
            <div className="card h-100">
                <div className="card-body" style={{ backgroundColor: 'white' }}>
                    <div className="row" >
                        <div className="col-md-4">
                            <img className="justify-content-left h-100 w-100 align-middle" src={ttecLogoUrl} alt="TTEC" />
                        </div>
                        <div className="col-md-8">
                            {empMetricData.max_metric_payout !== undefined &&
                                empMetricData.max_metric_payout !== null && empMetricData.max_metric_payout > 0 ? (
                                <div className="row pe-3">
                                    <div className="row">
                                        <div className="col-md-8 pb-1 ">Projected Hours</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-7 w-90 " style={{ overflow: 'hidden' }}>
                                            <input
                                                className="rounded border"
                                                id="hours"
                                                type="number"
                                                pattern="[0-9]*"
                                                inputMode="numeric"
                                                onChange={nameInputChangeHandler}
                                                value={enteredHours}
                                            />
                                            {!enteredlessthan80HoursIsValid && (
                                                <p className="error-text-payoutcalc">
                                                    You must work at least 80 hours to qualify for a payout
                                                </p>
                                            )}
                                            {!enteredgreaterthan180HoursIsValid && (
                                                <p className="error-text-payoutcalc" >
                                                    A normal work month is 160 hours, please get approval for the
                                                    extra hours.
                                                </p>
                                            )}
                                            {hoursInputIsInvalid && (
                                                <p className="error-text-payoutcalc">
                                                    Hours must not be empty.
                                                </p>
                                            )}
                                        </div>

                                        <div className="col-md-4 align-right">
                                            {/* <button
                                                className="btn-primary"
                                                onClick={formSubmissionHandler}
                                            >
                                                <span style={{ color: 'white' }}>Calculate</span>
                                            </button> */}
                                            <Button
                                                type="button"
                                                onClick={formSubmissionHandler}
                                                className="btn-success"
                                                label="Calculate"
                                            />
                                        </div>
                                    </div>

                                    <div className="row rounded mt-2 ms-2 w-100" style={{ backgroundColor: '#edf4f8' }} >
                                        {empMetricData.max_minus_2_payout > 0 ? (
                                            <div
                                                className="col-md-6 mb-3"
                                                style={{ backgroundColor: '#edf4f8', borderRight: '1px solid #2AA154' }}
                                            >
                                                <div className="">
                                                    <div className="bg-transparent ms-0">
                                                        <div className="card-body bg-transparent">
                                                            <div className="row">
                                                                <div className="payout-at-text">
                                                                    {'Payout at'}
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-mid-6">
                                                                    {circularprogressbar(
                                                                        empMetricData.total_metric_count - 2,
                                                                        empMetricData.total_metric_count
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="row mt-2">
                                                                {target3 ? (
                                                                    <div className="center">
                                                                        <span className="target-align" >
                                                                            `$${Number(target3)?.toFixed(2)}`
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <div />
                                                                )}

                                                                <div style={{ display: 'contents' }}>
                                                                    <span className="dot">
                                                                        &nbsp;
                                                                    </span>
                                                                    <span className="payout-text align-text-top ps-2">
                                                                        {Number(empMetricData.max_minus_2_payout *
                                                                            100).toFixed(2)}{' '}
                                                                        % Bonus at <span>&nbsp;</span>
                                                                    </span>
                                                                    <span className="payout-text">
                                                                        {empMetricData.total_metric_count - 2}{' '}
                                                                        Metrics
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <p />
                                        )}
                                        <div
                                            className="col-md-6 mb-3"
                                            style={{
                                                backgroundColor: '#edf4f8', borderRight: '1px solid #2AA154'
                                            }}
                                        >
                                            <div className="">
                                                <div className="bg-transparent ms-0">
                                                    <div className="card-body bg-transparent p-0">
                                                        <div className="row">
                                                            <div className="payout-at-text">
                                                                {'Payout at'}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                {circularprogressbar(
                                                                    empMetricData.total_metric_count - 1,
                                                                    empMetricData.total_metric_count
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="mt-2">
                                                            {target4 ? (
                                                                <div className="center">
                                                                    <span className="target-align"
                                                                        style={{
                                                                            display: 'block', width: '100%'
                                                                        }}
                                                                    >
                                                                        {Number(target4)?.toFixed(2)}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div />
                                                            )}

                                                            <div
                                                                style={{ display: 'contents' }}
                                                                className="mt-3 d-block text-center"
                                                            >
                                                                <span className="dot">
                                                                    &nbsp;
                                                                </span>
                                                                <span className="payout-text align-text-top ps-2" >
                                                                    {Number(empMetricData.max_minus_1_payout * 100).toFixed(2)} %
                                                                    Bonus at <span>&nbsp;</span>
                                                                </span>
                                                                <span className="payout-text-align" >
                                                                    {empMetricData.total_metric_count - 1}{' '}
                                                                    Metrics
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="col-md-6 mb-3"
                                            style={{ backgroundColor: '#edf4f8' }}
                                        >
                                            <div className="">
                                                <div className="bg-transparent ms-0">
                                                    <div className="card-body bg-transparent p-0" >
                                                        <div className="row">
                                                            <div className="payout-at-text">
                                                                {'Payout at'}
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                {circularprogressbar(
                                                                    empMetricData.total_metric_count,
                                                                    empMetricData.total_metric_count
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="mt-2">
                                                            {target5 ? (
                                                                <div className="center">
                                                                    <span
                                                                        className="target-align"
                                                                        style={{
                                                                            display: 'block', width: '100%'
                                                                        }}
                                                                    >
                                                                        {Number(target5)?.toFixed(2)}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div />
                                                            )}

                                                            <div
                                                                style={{ display: 'contents' }}
                                                                className="mt-3 d-block text-center"
                                                            >
                                                                <span className="dot">
                                                                    &nbsp;
                                                                </span>
                                                                <span className="payout-text align-text-top ps-2">
                                                                    {Number(empMetricData.max_metric_payout * 100).toFixed(2)} %
                                                                    Bonus at <span>&nbsp;</span>
                                                                </span>
                                                                <span className="payout-text-align" >
                                                                    {empMetricData.total_metric_count} Metrics
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{ fontSize: '12px', fontWeight: '600' }}
                                        className="mt-3"
                                    >
                                        <img
                                            className="iconDetails"
                                            src={groupExclam}
                                            alt="TTEC"
                                        />{' '}
                                        Calculation only provides an estimate.
                                    </div>
                                </div>) : (
                                <p>No Data Found</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};